import "./index.scss";
import Map from "./components/Map";
import React from "react";
// import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";

// export const API = process.env.REACT_APP_API || `${window.origin}/wp-json`;

function App() {
  return (
    <div className="App">
      <Map />
    </div>
  );
}

export default App;
